/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Before_2Inputs */

const en_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected by ATS before a human sees it`)
};

const de_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vom ATS abgelehnt, bevor ein Mensch ihn sieht`)
};

const fr_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejeté par l'ATS avant qu'un humain ne le voie`)
};

const es_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazado por el ATS antes de que lo vea una persona`)
};

const it_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scartato dall'ATS prima che un essere umano lo veda`)
};

const nl_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afgewezen door ATS voordat een mens het ziet`)
};

const pl_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzucone przez ATS, zanim zobaczy je człowiek`)
};

const fi_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS hylkää ennen kuin ihminen ehtii nähdä`)
};

const da_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afvist af ATS, før et menneske ser det`)
};

const sv_landing_before_2 = /** @type {(inputs: Landing_Before_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bortsorterad av ATS innan en människa ser det`)
};

/**
* | output |
* | --- |
* | "Rejected by ATS before a human sees it" |
*
* @param {Landing_Before_2Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_before_2 = /** @type {((inputs?: Landing_Before_2Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Before_2Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_before_2(inputs)
	if (locale === "fr") return fr_landing_before_2(inputs)
	if (locale === "es") return es_landing_before_2(inputs)
	if (locale === "it") return it_landing_before_2(inputs)
	if (locale === "nl") return nl_landing_before_2(inputs)
	if (locale === "pl") return pl_landing_before_2(inputs)
	if (locale === "fi") return fi_landing_before_2(inputs)
	if (locale === "da") return da_landing_before_2(inputs)
	if (locale === "sv") return sv_landing_before_2(inputs)
	return en_landing_before_2(inputs)
});